import React from "react";
import DashboardLayout from "../components/DashboardLayout";

function Analytics() {
  return (
    <DashboardLayout headerTitle="Analytics">
      <div className="mt-[20px] text-center">Page Contents</div>
    </DashboardLayout>
  );
}

export default Analytics;
